import { ApiError } from 'src/error/customError/ApiError';
import { NotFoundError } from 'src/error/customError/NotFoundError';
import { InternalServerError } from 'src/error/customError/InternalServerError';
import { InvalidError } from 'src/error/customError/InvalidError';
import { UnauthorizedError } from 'src/error/customError/UnauthorizedError';
import { PermissionError } from 'src/error/customError/PermissionError';
export const apiErrorHandler = (e: ApiError | any): ApiError | Error => {
  if (e instanceof ApiError) {
    switch (e.type) {
      case 'NotFoundError':
        throw new NotFoundError(e);
      case 'InvalidError':
        throw new InvalidError(e);
      case 'UnauthorizedError':
        throw new UnauthorizedError(e);
      case 'PermissionError':
        throw new PermissionError(e);
      default:
        throw new InternalServerError(e);
    }
  }
  return new Error(e);
};
